import React, { Component } from "react";

class VehicleReportTablePivot extends Component {
  render() {
    const { pivot } = this.props;

    return (
      <div style={{ display: "flex" }}>
        {pivot.map((item, index) => {
          return (
            <div key={"pivot" + pivot[0] + "index" + index} style={{ width: item.width + "px" }}>
              <b>{item.value}</b>
            </div>
          );
        })}
      </div>
    );
  }
}

export default VehicleReportTablePivot;
